<template>
	<div>
		<Layout :navFixed="true"  :withImage="true" :hideFooterDecoration="true">

			<template v-if="!path">
				<div class="header-image header-image-default"  >Productos</div>
				<HomeCategories />
			</template>

			<template v-if="path">
				
				<div class="header-image "
					:style="category.image ? 'background-image:url(' + category.image + ')' : ''"
				  >{{category.title}}</div>

				<div class="separation-line" v-if="category">
					<div class="container">
						<div class="row">
							<div class="col" v-html="category.slogan"></div>
						</div>
					</div>
					
				</div>
				
				<div class="container">
					<div class="row row-xs mt-4 mb-5">
						<div class="col-12 col-md-6 col-lg-4" v-for="item in items" :key="item.id">
							<ProductItem :item="item" />
						</div>
					</div>
				</div>
			</template>


		</Layout>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import Layout from '@/components/Layout'
import ProductItem from '@/components/ProductItem'
import HomeCategories from "@/views/home/HomeCategories"

export default {
	name: 'Products',
	components: {
		Layout,
		ProductItem,
		HomeCategories

	},
	
	metaInfo() {
		return {
			title: this.path ? this.path : 'Productos',
		}
	},
	beforeMount(){
		if(this.$route.params.path){
			this.path = this.$route.params.path
			this.loadCategory()
			this.loadProducts()
		}
	},
	data() {
		return {
			category:null,
			items: [],
			path:null
		}
	},
	
	methods: {
		loadProducts() {
			return this.$apollo
				.query({
					query: gql`
						query($category: String, $status: String) {
							campers(category: $category, status: $status) {
								data {
									id
									name
									category{
										id title slug
									}
									slug
									dimensions
									capacity
									waterTank	
									image {
										id
										type
										filename
										url
										urlThumb
									}
									
								}
							}
						}
					`,
					variables: {
						category: this.path,
						status: 'ACTIVE',
					},
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.items = data.campers.data
				})
				.catch(() => {})
		},
		loadCategory() {
			return this.$apollo
				.query({
					query: gql`
						query($slug: String) {
							camperCategory(slug: $slug) {
								id
								title
								slogan
								slug
								image {
									id
									type
									filename
									url
									urlThumb
								}
							}
						}
					`,
					variables: {
						slug: this.path,
					},
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.category = data.camperCategory
					if(this.category.slug == 'motorhome') this.category.image = require('@/assets/img/products-motorhome.jpeg')
					if(this.category.slug == 'campers') this.category.image = require('@/assets/img/products-campers.jpeg')
					if(this.category.slug == 'casas-rodantes') this.category.image = require('@/assets/img/products-casas-rodantes.jpeg')
					if(this.category.slug == 'equipamiento-y-trabajos-personalizados') this.category.image = require('@/assets/img/products-equipamiento.jpeg')
					if(this.category.slug == 'trailers') this.category.image = require('@/assets/img/products-trailers.jpeg')
					if(this.category.slug == 'modulos-y-cabinas') this.category.image = require('@/assets/img/products-modulos-y-cabinas.jpeg')
				})
				.catch(() => {})
		},
	},
}
</script>

<style scoped lang="scss">
.separation-line{
	font-size: 1.1rem;
}


</style>
